import React from 'react';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';

import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

export const Toast = (props) => {
  const { children, type, closeToast } = props;
  const { formatMessage } = useIntl();

  const content =
    children && typeof children === 'object' && 'id' in children && 'defaultMessage' in children
      ? formatMessage(children)
      : children;

  return (
    <Alert
      variant="filled"
      severity={type}
      data-element={`toast.${type}`}
      iconMapping={{
        success: <CheckCircleOutlineOutlinedIcon fontSize="inherit" />,
      }}
      action={
        <Button variant="text" size="small" sx={{ color: 'common.white' }} onClick={closeToast}>
          {formatMessage({ id: 'button.close', defaultMessage: 'Close' })}
        </Button>
      }
    >
      {content}
    </Alert>
  );
};

const renderToast =
  (type) =>
  (child, options = {}) =>
    toast.success(<Toast type={type}>{child}</Toast>, options);

export default {
  success: renderToast('success'),
  info: renderToast('info'),
  warn: renderToast('warning'),
  error: renderToast('error'),
};
